import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';

export type ConfirmPositionDialogData = {
  causale: string,
  descrizioneServizio: string | null | undefined
  descrizioneEnteCreditore: string | null | undefined,
  descrizioneCategoria: string | null | undefined,
}

@Component({
    selector: 'app-confirm-position-modal',
    templateUrl: './confirm-position-modal.component.html',
    styleUrls: ['./confirm-position-modal.component.scss'],
    standalone: false
})
export class ConfirmPositionModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmPositionDialogData,
    public dialogRef: MatDialogRef<ConfirmPositionModalComponent>,
    public translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
  }

  close(result: string) {
    this.dialogRef.close(result)
  }
}
